import { getAccount, } from "wagmi/actions";
import { wagmiConfig, } from "@config";

import type { USER_REFERRAL_ID, } from "./types"
import type * as Identity from "@bracket/identity/types";
import type { PointsStore, } from "./PointsStore";


export const isUserReferralId = ( value: unknown, ):value is USER_REFERRAL_ID => {
	return typeof value === "string" && value.length === 8;
}

/**
 * Fish the URL's query params for a ref or refer value.
 * @returns {string|undefined}
 */
export const refereeFromQueryParams = (): string | undefined => {
	const { search, } = globalThis.location;
	if (search) {
		const parts = search.slice(1).split("&");
		const part = parts.find(part => ["ref", "refer"].includes(part.split("=")[0]))?.split("=");
		if (part) {
			return part[1];
		}
	}
}


export const performCheckin = async ( address: string, referee?: string, ): Promise<Identity.User> => {
	const url = `/checkin?address=${address}${referee ? `&referee=${referee}` : ""}`;
	const response = await fetch(url);
	if( response.ok ) {
		const result = await response.json();
		if( result?.success ) {
			return result.user as Identity.User;
		}
	}
	throw new Error("PointStore::performCheckin failed to gain a valid server response");
}


export const resolveConfirmation = async ( user: Identity.User, state: PointsStore, ): Promise<Identity.User> => {

	// are we already confirmed? great , be gone.
	const { address, } = getAccount(wagmiConfig);
	const { wallet, confirmed, } = user;
	const { user_referral_submitted, } = state;

	// is the user confirmed as far as the state is concerned on the main assoc?
	if(confirmed) return user;

	//current wallet/user && cache says we're confirmed - we believe it.
	if(wallet === address && user_referral_submitted) {
		return confirmUser(user);
	}

	// return the user unconfirmed
	return user;
}


export const confirmUser = async ( user: Identity.User, ): Promise<Identity.User> => {
	try {
		user.confirmed = true;
		const response = await fetch("/update/user", {
			method: "POST",
			body: JSON.stringify({user: user,})
		});
		if(response.ok) {
			const result = await response.json();
			const { success, user, } = result;
			if(success && user) {
				return user as Identity.User;
			}
		}
		throw new Error("invalid server response.");
	}
	catch( err ) {
		throw new Error(`PointsStore::confirmUser failed - ${err instanceof Error ? err.message : ""}`);
	}
}


export const referUser = async ( user: Identity.User, referee: string, ): Promise<[true, Identity.User]|[false, string]> => {

	if(!user)
		throw new Error("PointsStore::referUser as not provided a valid user");

	if(!referee)
		throw new Error("PointsStore::referUser as not provided a valid referee");

	const response = await fetch("/refer", {
		method: "POST",
		body: JSON.stringify({ user, refid: referee, }),
	});

	if(response.ok) {
		const result = await response.json();
		if(result.success) {
			return [ true, result.user, ];
		}
		return [ false, result.message, ];
	}
	throw new Error("PointsStore::referUser received an invalid server response");
}


export const isUserRejectionError = ( error: unknown ):boolean => {
	if(error instanceof Error) {
		// metamask error.
		if("code" in error && error.code === 4001) return true;
	}
	return false
}


export const assertClaimrLoaded = (): true => {
	try {
		// biome-ignore lint/suspicious/noExplicitAny: will require ambient mode global definitions otherwise.
		if(typeof (globalThis as any).claimr.connect_wallet === "function") {
			return true;
		}
		throw new Error("not ready");
	}
	catch( err ) {
		throw new Error("PointsStore::claimr client is not present.");
	}
}
